import { render, staticRenderFns } from "./EditFeature.vue?vue&type=template&id=6e1842aa&"
import script from "./EditFeature.vue?vue&type=script&lang=js&"
export * from "./EditFeature.vue?vue&type=script&lang=js&"
import style0 from "./EditFeature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports